<template>
  <!-- Port of the Laravel Pro panel multi select (fyxify resources/js/components/partials/proMultiSelectDropdown.vue):
       button "Select <field>" / "N Selected", list with search, "Select All" and checkboxes. Vue 3 v-model = array of
       option values. The list overlays the fields below (like Laravel); inside a scrolling drawer it scrolls with it. -->
  <div ref="root" class="relative w-full font-roboto">
    <button type="button" :disabled="disabled"
      class="w-full h-[40px] px-[14px] flex items-center justify-between gap-[8px] rounded-[8px] border-1 bg-[#fff] text-left text-[14px] disabled:bg-[#F7F8FA] disabled:cursor-not-allowed"
      :class="isOpen ? 'border-[#8479E1]' : 'border-[#E1E5EF]'" @click="toggle">
      <span class="truncate" :class="modelValue.length ? 'text-[#333333]' : 'text-[#999999]'">
        {{ modelValue.length ? modelValue.length + ' Selected' : placeholderText }}
      </span>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="flex-shrink-0 transition-transform" :class="{ 'rotate-180': isOpen }">
        <path d="M6 9l6 6 6-6" stroke="#666666" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <div v-if="isOpen" class="absolute left-0 right-0 top-full z-30 mt-[6px] p-[8px] flex flex-col gap-[4px] rounded-xl border-1 border-[#E1E5EF] bg-[#fff] shadow-[0px_4px_12px_0px_#0000001A]">
      <!-- search -->
      <div v-if="isSearchable" class="relative">
        <svg class="absolute left-[10px] top-1/2 -translate-y-1/2 pointer-events-none" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="11" cy="11" r="7" stroke="#999999" stroke-width="2" /><path d="m20 20-3.5-3.5" stroke="#999999" stroke-width="2" stroke-linecap="round" />
        </svg>
        <input v-model="searchQuery" type="text" placeholder="Search..."
          class="w-full h-[36px] pl-[34px] pr-[10px] rounded-[5px] border-1 border-[#E1E5EF] text-[13px] text-[#333333] outline-none focus:border-[#8479E1]">
      </div>
      <div class="max-h-60 overflow-auto">
        <!-- Select All -->
        <label class="pmsRow" @click.prevent="toggleSelectAll">
          <span class="pmsBox" :class="{ on: isAllSelected }"><svg v-if="isAllSelected" viewBox="0 0 20 20" fill="#fff"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg></span>
          Select All
        </label>
        <label v-for="option in filteredOptions" :key="option[valueKey]" class="pmsRow"
          :class="{ picked: isSelected(option) }" @click.prevent="toggle1(option)">
          <span class="pmsBox" :class="{ on: isSelected(option) }"><svg v-if="isSelected(option)" viewBox="0 0 20 20" fill="#fff"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg></span>
          {{ option[labelKey] }}
        </label>
        <p v-if="!filteredOptions.length" class="m-0 py-2 text-center text-[13px] text-[#999999]">No results found</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    labelKey: { type: String, default: "label" },
    valueKey: { type: String, default: "value" },
    fieldName: { type: String, default: "" },
    isSearchable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return { isOpen: false, searchQuery: "" };
  },
  computed: {
    placeholderText() {
      return this.fieldName.toLowerCase().includes("select") ? this.fieldName : `Select ${this.fieldName}`;
    },
    selectedSet() {
      return new Set(this.modelValue.map(String));
    },
    isAllSelected() {
      return this.options.length > 0 && this.options.every(o => this.selectedSet.has(String(o[this.valueKey])));
    },
    filteredOptions() {
      if (!this.searchQuery) return this.options;
      const q = this.searchQuery.toLowerCase();
      return this.options.filter(o => String(o[this.labelKey]).toLowerCase().includes(q));
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onOutside);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.onOutside);
  },
  methods: {
    isSelected(option) {
      return this.selectedSet.has(String(option[this.valueKey]));
    },
    emit(values) {
      this.$emit("update:modelValue", values);
      this.$emit("change", values);
    },
    toggle1(option) {
      const v = option[this.valueKey];
      this.emit(this.isSelected(option)
        ? this.modelValue.filter(x => String(x) !== String(v))
        : [...this.modelValue, v]);
    },
    toggleSelectAll() {
      this.emit(this.isAllSelected ? [] : this.options.map(o => o[this.valueKey]));
    },
    toggle() {
      this.isOpen = !this.isOpen;
      this.searchQuery = "";
    },
    onOutside(e) {
      if (this.isOpen && this.$refs.root && !this.$refs.root.contains(e.target)) {
        this.isOpen = false;
        this.searchQuery = "";
      }
    },
  },
};
</script>
